import React from "react";
import { useNavigate } from "react-router-dom";

export default function PageSwitcher({ active }) {
  const navigate = useNavigate();

  return (
    <div className="sm-switcher">
      <button
        className={`sm-switcher__btn ${active === "substations" ? "is-active" : ""}`}
        onClick={() => navigate("/substations")}
      >
        Подстанциялар
      </button>
      <button
        className={`sm-switcher__btn ${active === "networks" ? "is-active" : ""}`}
        onClick={() => navigate("/networks")}
      >
        Тармоқлар
      </button>
    </div>
  );
}
